"use client";

import { Button, Dialog, DialogTitle, Flex, Text, TextFieldInput, VisuallyHidden } from "@radix-ui/themes";
import { useEffect, useState } from "react";
import { useTNsViaAccountIdQuery } from "@/app/account-settings/utils";
import useUBStore from "@/stores/UBStore";

export interface RequestUbidDialogProps {
    open?: boolean;
    setOpen?: (open: boolean) => void;
}

function RequestUbidDialog({ open, setOpen }: RequestUbidDialogProps) {
    const { ubid, setUbid } = useUBStore();
    const [txtUBID, setTxtUBID] = useState<string>(ubid);
    const [validationFailed, setValidationFailed] = useState(false);
    const [validatingUbid, setValidatingUbid] = useState(false);
    const [submittedUbid, setSubmittedUbid] = useState("");

    const { refetch } = useTNsViaAccountIdQuery(submittedUbid);

    useEffect(() => {
        if (submittedUbid) {
            setValidationFailed(false);
            setValidatingUbid(true);
            refetch()
                .then((resp) => {
                    const { data: res } = resp;
                    if (res && Array.isArray(res) && res.length > 0) {
                        setUbid(submittedUbid);
                        setValidationFailed(false);
                        setValidatingUbid(false);
                        if (setOpen) setOpen(false);
                    } else {
                        setValidationFailed(true);
                        setValidatingUbid(false);
                    }
                })
                .catch(() => {
                    setValidationFailed(true);
                    setValidatingUbid(false);
                });
        }
    }, [submittedUbid]);

    const handleUBIDChange = (e: { target: { value: string } }) => {
        setTxtUBID(e.target.value);
    };

    const handleNext = () => {
        if (txtUBID !== submittedUbid) setSubmittedUbid(txtUBID);
    };

    return (
        <Dialog.Root open={open} onOpenChange={setOpen}>
            <Dialog.Content className="DialogContent">
                <VisuallyHidden>
                    <DialogTitle>Request UBID</DialogTitle>
                </VisuallyHidden>
                <Flex gap="5" direction="column">
                    <label>
                        <Text as="div" size="2" mb="1" weight="bold">
                            Universal Billing Subaccount ID (UBID) test
                        </Text>
                        <TextFieldInput
                            size="3"
                            type="text"
                            name="ubid"
                            value={txtUBID}
                            onChange={handleUBIDChange}
                            maxLength={100}
                            placeholder="UBID"
                            required
                        />
                        {validationFailed && <Text className="text-att-red font-medium text-sm">Please enter a valid UBID</Text>}
                        {validatingUbid && <Text className="text-att-cobalt-blue font-medium text-sm">Validating the provided UBID...</Text>}
                    </label>
                    <Flex gap="3" justify="end">
                        <Button variant="surface" onClick={handleNext} className="px-6 py-3 h-10 rounded-full cursor-pointer">
                            Update
                        </Button>
                    </Flex>
                </Flex>
            </Dialog.Content>
        </Dialog.Root>
    );
}

export default RequestUbidDialog;
